import { useOutsideClick } from '@chakra-ui/react'
import { useRecoilState } from 'recoil'
import { ItList } from 'types/graphql'

import { navigate, routes, useLocation } from '@redwoodjs/router'

import { creatorDraftItListsState } from 'src/atoms/creator.atom'
import { toast } from 'src/components/widgets/Toaster'
import { useCurrentUser } from 'src/lib/hooks/auth/useCurrentUser'

const CLONE_TOAST_ID = 'clone-toast'

export default function useItListOverflowMenu(
  itList: Pick<ItList, 'id' | 'status'>
) {
  const { id: userId } = useCurrentUser()
  const { pathname } = useLocation()
  const [isOpen, setIsOpen] = React.useState<boolean>(false)
  const [draftItLists, setDraftItLists] = useRecoilState(
    creatorDraftItListsState
  )
  const ref = React.useRef()

  useOutsideClick({
    ref,
    handler() {
      setIsOpen(false)
    },
  })

  const onClone: React.MouseEventHandler = React.useCallback(
    async (ev) => {
      ev.preventDefault()
      ev.stopPropagation()
      setIsOpen(false)
      toast('loading', 'Duplicating...', null, {
        id: CLONE_TOAST_ID,
      })
      const res = await fetch(`${window.RWJS_API_URL}/createDraft`, {
        method: 'POST',
        body: JSON.stringify({
          currentUserId: userId,
          sourceId: itList.id,
          type: 'duplicate',
        }),
      })
      toast(
        'success',
        'Done!',
        {
          action:
            pathname === routes.createdByMe()
              ? null
              : {
                  label: 'View Drafts',
                  onClick: () => navigate(routes.createdByMe()),
                },
        },
        { id: CLONE_TOAST_ID }
      )
      // If on the createdByMe page, we need to update the draft list dynamically
      if (pathname === routes.createdByMe()) {
        const draft = await res.json()
        setDraftItLists([...draftItLists, draft])
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [itList.id, userId]
  )

  return { onClone, isOpen, setIsOpen, ref }
}
